<template lang="pug">
  v-snackbar(
    bottom
    :value="hasNotifications"
    :timeout="0"
    :color="notify.type"
    v-if="notify"
  ) {{ notify.text }}
    v-btn(
      color="white"
      text
      @click="close()"
    ) Закрыть

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'hasNotifications',
      'notify'
    ])
  },
  methods: {
    close() {
      this.$store.commit('CLEAR_NOTIFICATION')
    }
  }
}
</script>
